<form-popup [(visible)]="visible" (visibleChange)="onVisibleChange($event)"
            (save)="onPopupSaveClick()"
            (open)="onOpen()"
            titleText="Edit Carrier"
            [isSaveDisabled]="isReadOnly">
    <carrier-form [data]="formData" [isReadOnly]="isReadOnly"></carrier-form>
</form-popup>
